
import * as React from 'react';

type IconComparadorProps = React.SVGProps<SVGSVGElement>;

export const IconComparador: React.FC<IconComparadorProps> = (props) => (
	<svg width="14" height="16" fill="#2E3C46" viewBox="0 0 14 16"  xmlns="http://www.w3.org/2000/svg"
	{...props}
	>
	<path d="M5 2.5C5 1.67188 5.67188 1 6.5 1H7.5C8.32812 1 9 1.67188 9 2.5V13.5C9 14.3281 8.32812 15 7.5 15H6.5C5.67188 15 5 14.3281 5 13.5V2.5ZM0 8.5C0 7.67188 0.671875 7 1.5 7H2.5C3.32812 7 4 7.67188 4 8.5V13.5C4 14.3281 3.32812 15 2.5 15H1.5C0.671875 15 0 14.3281 0 13.5V8.5ZM11.5 3H12.5C13.3281 3 14 3.67188 14 4.5V13.5C14 14.3281 13.3281 15 12.5 15H11.5C10.6719 15 10 14.3281 10 13.5V4.5C10 3.67188 10.6719 3 11.5 3Z" />
	</svg>
);


